import { createFileRoute } from '@tanstack/react-router'

import type { PerfilId } from '@/lib/visoes'

import { DetalheTime } from '@/features/visao-geral/detalhe-time'

export const Route = createFileRoute('/$perfil/times/$timeId')({
  component: Tela,
})

function Tela() {
  const { perfil, timeId } = Route.useParams()
  // A chave faz o resultado das tarefas paradas de um time não passar para o outro.
  return <DetalheTime key={timeId} timeId={timeId} perfil={perfil as PerfilId} />
}
